// Translation keys for the chat application
// These should be integrated with the main translation system
import { TranslationLanguage } from '@common/ts/types';

export const TRANSLATIONS = {
  // Error page translations
  errors: {
    projectDoesNotExist: {
      title: (isEmpathy: boolean) => `${isEmpathy ? 'Project' : 'Tellet'} does not exist`,
      message: "We're sorry but this project does not exist.",
    },
    maximumParticipants: {
      title: 'Maximum amount of participants',
      message:
        'This study has reached its maximum amount of responses and is no longer accepting new responses.',
    },
    somethingMissing: {
      title: 'Something missing',
      message: 'This page is unavailable or does not exist.',
    },
    projectCompleted: {
      title: 'Project is completed',
      message: 'This study has been completed and is no longer accepting new responses.',
    },
    projectInDraftOrReadyStatus: {
      title: 'Project is not published',
      message: 'Because study has not been published yet, it is not accepting responses.',
    },
  },

  // Redirect translations
  redirect: {
    redirectingIn: 'Redirecting in',
    seconds: 'seconds...',
    cancel: 'Cancel',
    returnToPanel: 'Return to Panel',
  },
};

export const SCREENING_QUESTIONS_TRANSLATION: Record<
  TranslationLanguage,
  { [key: string]: string }
> = {
  af: {
    next: 'Volgende',
    question: 'Vraag',
    writeInNumbers: 'skryf in nommers',
    finish: 'Voltooi',
    errorTranslatingTitle: 'Vertaal Fout',
    errorTranslatingDescription:
      'Oeps! Ons kon hierdie vraag nie vertaal nie. Die oorspronklike word in plaas daarvan vertoon. Kontak asseblief ons ondersteuning by: info@tellet.ai vir hulp.',
  },
  am: {
    next: 'ቀጣይ',
    question: 'ጥያቄ',
    writeInNumbers: 'በቁጥሮች ይጻፉ',
    finish: 'ጨርስ',
    errorTranslatingTitle: 'የትርጉም ስህተት',
    errorTranslatingDescription:
      'ይቅርታ! ይህን ጥያቄ መተርጎም አልቻልንም። በምትኩ ዋናው እየታየ ነው። እባክዎ ለእርዳታ ድጋፋችንን በ info@tellet.ai ያግኙ።',
  },
  ar: {
    next: 'التالي',
    question: 'سؤال',
    writeInNumbers: 'اكتب بالأرقام',
    finish: 'إنهاء',
    errorTranslatingTitle: 'خطأ في الترجمة',
    errorTranslatingDescription:
      'عذرًا! لم نتمكن من ترجمة هذا السؤال. سيتم عرض النسخة الأصلية بدلاً من ذلك. يرجى الاتصال بدعمنا على: info@tellet.ai للحصول على المساعدة.',
  },
  hy: {
    next: 'Հաջորդը',
    question: 'Հարց',
    writeInNumbers: 'գրեք թվերով',
    finish: 'Ավարտել',
    errorTranslatingTitle: 'Թարգմանության սխալ',
    errorTranslatingDescription:
      'Ողջույն! Մենք չկարողացանք թարգմանել այս հարցը։ Ցուցադրվում է բնօրինակը։ Խնդրում ենք կապնվել մեր աջակցությանը՝ info@tellet.ai համար օգնություն.',
  },
  az: {
    next: 'Növbəti',
    question: 'Sual',
    writeInNumbers: 'rəqəmlərlə yazın',
    finish: 'Bitir',
    errorTranslatingTitle: 'Tərcümə Xətası',
    errorTranslatingDescription:
      'Bağışlayın! Bu sualı tərcümə edə bilmədik. Əvəzində orijinalı göstərilir. Yardım üçün zəhmət olmasa bizim dəstək xidməti ilə əlaqə saxlayın: info@tellet.ai.',
  },
  be: {
    next: 'Далей',
    question: 'Пытанне',
    writeInNumbers: 'напішыце лічбамі',
    finish: 'Скончыць',
    errorTranslatingTitle: 'Памылка перакладу',
    errorTranslatingDescription:
      'Прабачце! Мы не змаглі перакласці гэтае пытанне. Паказваецца арыгінал. Калі ласка, звяжыцеся з нашай падтрымкай па адрасе: info@tellet.ai.',
  },
  bs: {
    next: 'Dalje',
    question: 'Pitanje',
    writeInNumbers: 'upišite brojevima',
    finish: 'Završi',
    errorTranslatingTitle: 'Greška u prevođenju',
    errorTranslatingDescription:
      'Žao nam je! Nismo mogli prevesti ovo pitanje. Umjesto toga prikazan je original. Molimo kontaktirajte našu podršku na: info@tellet.ai.',
  },
  bg: {
    next: 'Следващ',
    question: 'Въпрос',
    writeInNumbers: 'напишете с цифри',
    finish: 'Край',
    errorTranslatingTitle: 'Грешка при превода',
    errorTranslatingDescription:
      'Съжаляваме! Не успяхме да преведем този въпрос. Показва се оригиналът. Моля, свържете се с нашата поддръжка на: info@tellet.ai.',
  },
  bn: {
    next: 'পরবর্তী',
    question: 'প্রশ্ন',
    writeInNumbers: 'সংখ্যায় লিখুন',
    finish: 'শেষ',
    errorTranslatingTitle: 'অনুবাদ ত্রুটি',
    errorTranslatingDescription:
      'দুঃখিত! আমরা এই প্রশ্নটি অনুবাদ করতে পারিনি। মূল সংস্করণ প্রদর্শিত হচ্ছে। অনুগ্রহ করে আমাদের সাপোর্টে যোগাযোগ করুন: info@tellet.ai.',
  },
  yue: {
    next: '下一個',
    question: '問題',
    writeInNumbers: '用數字寫',
    finish: '完成',
    errorTranslatingTitle: '翻譯錯誤',
    errorTranslatingDescription:
      '唉！我哋翻譯唔到呢條問題。而家顯示原文。如需協助，請聯絡我哋嘅支援：info@tellet.ai',
  },
  ca: {
    next: 'Següent',
    question: 'Pregunta',
    writeInNumbers: 'escriu en números',
    finish: 'Acaba',
    errorTranslatingTitle: 'Error de traducció',
    errorTranslatingDescription:
      "Ho sentim! No hem pogut traduir aquesta pregunta. Es mostra l'original. Si us plau, contacteu amb el nostre suport a: info@tellet.ai.",
  },
  zh: {
    next: '下一步',
    question: '问题',
    writeInNumbers: '用数字写',
    finish: '完成',
    errorTranslatingTitle: '翻译错误',
    errorTranslatingDescription:
      '抱歉！我们无法翻译这个问题。显示原文。请联系支持： info@tellet.ai。',
  },
  hr: {
    next: 'Dalje',
    question: 'Pitanje',
    writeInNumbers: 'upišite brojevima',
    finish: 'Završi',
    errorTranslatingTitle: 'Greška u prevođenju',
    errorTranslatingDescription:
      'Žao nam je! Nismo mogli prevesti ovo pitanje. Umjesto toga prikazan je original. Molimo kontaktirajte našu podršku na: info@tellet.ai.',
  },
  cs: {
    next: 'Další',
    question: 'Otázka',
    writeInNumbers: 'napište čísly',
    finish: 'Dokončit',
    errorTranslatingTitle: 'Chyba překladu',
    errorTranslatingDescription:
      'Omlouváme se! Tento dotaz se nám nepodařilo přeložit. Místo toho se zobrazuje originál. Kontaktujte prosím naši podporu na: info@tellet.ai.',
  },
  da: {
    next: 'Næste',
    question: 'Spørgsmål',
    writeInNumbers: 'skriv med tal',
    finish: 'Afslut',
    errorTranslatingTitle: 'Oversættelsesfejl',
    errorTranslatingDescription:
      'Beklager! Vi kunne ikke oversætte dette spørgsmål. Den originale vises i stedet. Kontakt venligst vores support på: info@tellet.ai.',
  },
  nl: {
    next: 'Volgende',
    question: 'Vraag',
    writeInNumbers: 'schrijf in cijfers',
    finish: 'Voltooien',
    errorTranslatingTitle: 'Vertaalfout',
    errorTranslatingDescription:
      'Sorry! We konden deze vraag niet vertalen. De originele versie wordt weergegeven. Neem contact op met onze ondersteuning via: info@tellet.ai.',
  },
  en: {
    next: 'Next',
    question: 'Question',
    writeInNumbers: 'write in numbers',
    finish: 'Finish',
    errorTranslatingTitle: 'Translation Error',
    errorTranslatingDescription:
      "Oops! We couldn't translate this question. The original is displayed instead. Please contact our support at: info@tellet.ai.",
  },
  et: {
    next: 'Järgmine',
    question: 'Küsimus',
    writeInNumbers: 'kirjutage numbritega',
    finish: 'Lõpeta',
    errorTranslatingTitle: 'Tõlke viga',
    errorTranslatingDescription:
      'Vabandame! Me ei suutnud seda küsimust tõlkida. Kuvatakse originaal. Palun võtke ühendust meie toega aadressil: info@tellet.ai.',
  },
  fi: {
    next: 'Seuraava',
    question: 'Kysymys',
    writeInNumbers: 'kirjoita numeroina',
    finish: 'Valmis',
    errorTranslatingTitle: 'Käännösvirhe',
    errorTranslatingDescription:
      'Anteeksi! Emme pystyneet kääntämään tätä kysymystä. Alkuperäinen näytetään sen sijaan. Ota yhteyttä tukeemme osoitteessa: info@tellet.ai.',
  },
  fr: {
    next: 'Suivant',
    question: 'Question',
    writeInNumbers: 'écrire en chiffres',
    finish: 'Terminer',
    errorTranslatingTitle: 'Erreur de traduction',
    errorTranslatingDescription:
      "Oups! Nous n'avons pas pu traduire cette question. L'original est affiché à la place. Veuillez contacter notre support à : info@tellet.ai.",
  },
  gl: {
    next: 'Seguinte',
    question: 'Pregunta',
    writeInNumbers: 'escribe en números',
    finish: 'Rematar',
    errorTranslatingTitle: 'Erro de tradución',
    errorTranslatingDescription:
      'Sentímolo! Non puidemos traducir esta pregunta. Amósase o orixinal. Contacta co noso soporte en: info@tellet.ai.',
  },
  de: {
    next: 'Weiter',
    question: 'Frage',
    writeInNumbers: 'in Zahlen schreiben',
    finish: 'Fertig',
    errorTranslatingTitle: 'Übersetzungsfehler',
    errorTranslatingDescription:
      'Entschuldigung! Wir konnten diese Frage nicht übersetzen. Stattdessen wird das Original angezeigt. Bitte kontaktieren Sie unseren Support unter: info@tellet.ai.',
  },
  el: {
    next: 'Επόμενο',
    question: 'Ερώτηση',
    writeInNumbers: 'γράψτε με αριθμούς',
    finish: 'Τέλος',
    errorTranslatingTitle: 'Σφάλμα μετάφρασης',
    errorTranslatingDescription:
      'Λυπούμαστε! Δεν μπορέσαμε να μεταφράσουμε αυτή την ερώτηση. Εμφανίζεται το πρωτότυπο. Παρακαλούμε επικοινωνήστε με την υποστήριξή μας στο: info@tellet.ai.',
  },
  iw: {
    next: 'הבא',
    question: 'שאלה',
    writeInNumbers: 'כתוב במספרים',
    finish: 'סיום',
    errorTranslatingTitle: 'שגיאת תרגום',
    errorTranslatingDescription:
      'אופס! לא הצלחנו לתרגם את השאלה הזו. מוצגת המקורית במקום זאת. אנא צרו קשר עם התמיכה שלנו בכתובת: info@tellet.ai.',
  },
  hi: {
    next: 'अगला',
    question: 'प्रश्न',
    writeInNumbers: 'संख्याओं में लिखें',
    finish: 'समाप्त',
    errorTranslatingTitle: 'अनुवाद त्रुटि',
    errorTranslatingDescription:
      'क्षमा करें! हम इस प्रश्न का अनुवाद नहीं कर सके। मूल संस्करण प्रदर्शित किया गया है। कृपया हमारी सहायता से संपर्क करें: info@tellet.ai.',
  },
  hu: {
    next: 'Következő',
    question: 'Kérdés',
    writeInNumbers: 'írja be számokkal',
    finish: 'Befejezés',
    errorTranslatingTitle: 'Fordítási hiba',
    errorTranslatingDescription:
      'Sajnáljuk! Nem tudtuk lefordítani ezt a kérdést. Az eredeti szöveg jelenik meg. Kérjük, lépjen kapcsolatba ügyfélszolgálatunkkal: info@tellet.ai.',
  },
  is: {
    next: 'Næsta',
    question: 'Spurning',
    writeInNumbers: 'skrifaðu með tölum',
    finish: 'Ljúka',
    errorTranslatingTitle: 'Þýðingarvilla',
    errorTranslatingDescription:
      'Fyrirgefðu! Við gátum ekki þýtt þessa spurningu. Upprunalega útgáfan er sýnd í staðinn. Vinsamlegast hafðu samband við stuðning okkar á: info@tellet.ai.',
  },
  it: {
    next: 'Avanti',
    question: 'Domanda',
    writeInNumbers: 'scrivi in numeri',
    finish: 'Fine',
    errorTranslatingTitle: 'Errore di traduzione',
    errorTranslatingDescription:
      "Ops! Non siamo riusciti a tradurre questa domanda. Viene mostrata l'originale. Contatta il nostro supporto a: info@tellet.ai.",
  },
  ja: {
    next: '次へ',
    question: '質問',
    writeInNumbers: '数字で書く',
    finish: '完了',
    errorTranslatingTitle: '翻訳エラー',
    errorTranslatingDescription:
      '申し訳ありません！この質問を翻訳できませんでした。代わりに原文が表示されます。サポートへのお問い合わせは: info@tellet.ai.',
  },
  ka: {
    next: 'შემდეგი',
    question: 'კითხვა',
    writeInNumbers: 'დაწერეთ რიცხვებით',
    finish: 'დასრულება',
    errorTranslatingTitle: 'თარგმნის შეცდომა',
    errorTranslatingDescription:
      'ბოდიში! ვერ შევძელით ამ კითხვის თარგმნა. ნაჩვენებია ორიგინალი. გთხოვთ დაუკავშირდეთ ჩვენს მხარდაჭერას: info@tellet.ai.',
  },
  kn: {
    next: 'ಮುಂದೆ',
    question: 'ಪ್ರಶ್ನೆ',
    writeInNumbers: 'ಸಂಖ್ಯೆಗಳಲ್ಲಿ ಬರೆಯಿರಿ',
    finish: 'ಪೂರ್ಣ',
    errorTranslatingTitle: 'ಅನುವಾದ ದೋಷ',
    errorTranslatingDescription:
      'ಕ್ಷಮಿಸಿ! ಈ ಪ್ರಶ್ನೆಯನ್ನು ಅನುವಾದಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ಬದಲಾಗಿ ಮೂಲವನ್ನು ತೋರಿಸಲಾಗುತ್ತದೆ. ಸಹಾಯಕ್ಕಾಗಿ ನಮ್ಮ ಬೆಂಬಲವನ್ನು ಸಂಪರ್ಕಿಸಿ: info@tellet.ai.',
  },
  kk: {
    next: 'Келесі',
    question: 'Сұрақ',
    writeInNumbers: 'сандармен жазыңыз',
    finish: 'Аяқтау',
    errorTranslatingTitle: 'Аударма қатесі',
    errorTranslatingDescription:
      'Кешіріңіз! Біз бұл сұрақты аудара алмадық. Оның орнына түпнұсқа көрсетіледі. Көмек үшін біздің қолдау қызметімізге хабарласыңыз: info@tellet.ai.',
  },
  ko: {
    next: '다음',
    question: '질문',
    writeInNumbers: '숫자로 쓰세요',
    finish: '완료',
    errorTranslatingTitle: '번역 오류',
    errorTranslatingDescription:
      '죄송합니다! 이 질문을 번역할 수 없습니다. 원본이 대신 표시됩니다. 지원팀에 문의하세요: info@tellet.ai.',
  },
  lv: {
    next: 'Nākamais',
    question: 'Jautājums',
    writeInNumbers: 'rakstiet ciparos',
    finish: 'Pabeigt',
    errorTranslatingTitle: 'Tulkošanas kļūda',
    errorTranslatingDescription:
      'Atvainojiet! Mēs nevarējām iztulkot šo jautājumu. Tiek rādīta oriģinālā versija. Lūdzu, sazinieties ar mūsu atbalsta dienestu: info@tellet.ai.',
  },
  lt: {
    next: 'Kitas',
    question: 'Klausimas',
    writeInNumbers: 'rašykite skaičiais',
    finish: 'Užbaigti',
    errorTranslatingTitle: 'Vertimo klaida',
    errorTranslatingDescription:
      'Atsiprašome! Nepavyko išversti šio klausimo. Rodyti originalą. Prašome susisiekti su mūsų palaikymo tarnyba: info@tellet.ai.',
  },
  mk: {
    next: 'Следно',
    question: 'Прашање',
    writeInNumbers: 'напишете со броеви',
    finish: 'Заврши',
    errorTranslatingTitle: 'Грешка при преводот',
    errorTranslatingDescription:
      'Жалиме! Не можевме да го преведеме ова прашање. Прикажан е оригиналот. Ве молиме контактирајте ја нашата поддршка на: info@tellet.ai.',
  },
  ms: {
    next: 'Seterusnya',
    question: 'Soalan',
    writeInNumbers: 'tulis dalam nombor',
    finish: 'Selesai',
    errorTranslatingTitle: 'Ralat Terjemahan',
    errorTranslatingDescription:
      'Maaf! Kami tidak dapat menterjemahkan soalan ini. Versi asal ditunjukkan sebagai ganti. Sila hubungi sokongan kami di: info@tellet.ai.',
  },
  mi: {
    next: 'Tēnā',
    question: 'Pātai',
    writeInNumbers: 'tuhi ki ngā nama',
    finish: 'Whakamutunga',
    errorTranslatingTitle: 'Hē Tautuhi',
    errorTranslatingDescription:
      'Aroha mai! Kāore e taea e mātou te whakamaori i tēnei pātai. Ka whakaatuhia te putanga taketake. Tena koa whakapā mai ki tā mātou tautoko i: info@tellet.ai.',
  },
  mr: {
    next: 'पुढे',
    question: 'प्रश्न',
    writeInNumbers: 'संख्यांमध्ये लिहा',
    finish: 'समाप्त',
    errorTranslatingTitle: 'अनुवाद त्रुटी',
    errorTranslatingDescription:
      'क्षमस्व! आम्ही हा प्रश्न अनुवादित करू शकलो नाही. त्याऐवजी मूळ प्रदर्शित केले जाते. कृपया आमच्या समर्थनाशी संपर्क साधा: info@tellet.ai.',
  },
  ne: {
    next: 'अर्को',
    question: 'प्रश्न',
    writeInNumbers: 'संख्यामा लेख्नुहोस्',
    finish: 'समाप्त',
    errorTranslatingTitle: 'अनुवाद त्रुटि',
    errorTranslatingDescription:
      'माफ गर्नुहोस्! हामीले यो प्रश्न अनुवाद गर्न सकेनौं। यसको सट्टा मूल संस्करण देखाइन्छ। कृपया हाम्रो समर्थनमा सम्पर्क गर्नुहोस्: info@tellet.ai.',
  },
  no: {
    next: 'Neste',
    question: 'Spørsmål',
    writeInNumbers: 'skriv med tall',
    finish: 'Fullfør',
    errorTranslatingTitle: 'Oversettelsesfeil',
    errorTranslatingDescription:
      'Beklager! Vi kunne ikke oversette dette spørsmålet. Originalen vises i stedet. Vennligst kontakt vår support på: info@tellet.ai.',
  },
  pa: {
    next: 'ਅਗਲਾ',
    question: 'ਸਵਾਲ',
    writeInNumbers: 'ਅੰਕਾਂ ਵਿੱਚ ਲਿਖੋ',
    finish: 'ਮੁਕੰਮਲ',
    errorTranslatingTitle: 'ਅਨੁਵਾਦ ਗਲਤੀ',
    errorTranslatingDescription:
      'ਮਾਫ ਕਰਨਾ! ਅਸੀਂ ਇਸ ਸਵਾਲ ਦਾ ਅਨੁਵਾਦ ਨਹੀਂ ਕਰ ਸਕੇ। ਇਸਦੀ ਥਾਂ ਮੂਲ ਵਰਜਨ ਦਿਖਾਇਆ ਜਾ ਰਿਹਾ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੇ ਸਹਾਇਤਾ ਨਾਲ ਸੰਪਰਕ ਕਰੋ: info@tellet.ai.',
  },
  fa: {
    next: 'بعدی',
    question: 'سوال',
    writeInNumbers: 'با اعداد بنویسید',
    finish: 'پایان',
    errorTranslatingTitle: 'خطای ترجمه',
    errorTranslatingDescription:
      'متاسفیم! نتوانستیم این سوال را ترجمه کنیم. نسخه اصلی به جای آن نمایش داده می‌شود. لطفاً با پشتیبانی ما تماس بگیرید: info@tellet.ai.',
  },
  pl: {
    next: 'Dalej',
    question: 'Pytanie',
    writeInNumbers: 'napisz cyframi',
    finish: 'Zakończ',
    errorTranslatingTitle: 'Błąd tłumaczenia',
    errorTranslatingDescription:
      'Przepraszamy! Nie mogliśmy przetłumaczyć tego pytania. Zamiast tego wyświetlana jest oryginalna wersja. Skontaktuj się z naszym wsparciem na: info@tellet.ai.',
  },
  pt: {
    next: 'Próximo',
    question: 'Pergunta',
    writeInNumbers: 'escreva em números',
    finish: 'Finalizar',
    errorTranslatingTitle: 'Erro de tradução',
    errorTranslatingDescription:
      'Desculpe! Não conseguimos traduzir esta pergunta. O original é exibido. Por favor, entre em contato com nosso suporte em: info@tellet.ai.',
  },
  tl: {
    next: 'Susunod',
    question: 'Tanong',
    writeInNumbers: 'isulat sa mga numero',
    finish: 'Tapusin',
    errorTranslatingTitle: 'Error sa Pagsasalin',
    errorTranslatingDescription:
      'Paumanhin! Hindi namin maisasalin ang tanong na ito. Ang orihinal ay ipinapakita sa halip. Mangyaring makipag-ugnayan sa aming suporta sa: info@tellet.ai.',
  },
  ro: {
    next: 'Următorul',
    question: 'Întrebare',
    writeInNumbers: 'scrie în cifre',
    finish: 'Finalizare',
    errorTranslatingTitle: 'Eroare de traducere',
    errorTranslatingDescription:
      'Ne pare rău! Nu am putut traduce această întrebare. Se afișează originalul. Vă rugăm să contactați suportul nostru la: info@tellet.ai.',
  },
  ru: {
    next: 'Далее',
    question: 'Вопрос',
    writeInNumbers: 'напишите цифрами',
    finish: 'Завершить',
    errorTranslatingTitle: 'Ошибка перевода',
    errorTranslatingDescription:
      'Извините! Мы не смогли перевести этот вопрос. Показан оригинал. Пожалуйста, свяжитесь с нашей поддержкой по адресу: info@tellet.ai.',
  },
  sr: {
    next: 'Даље',
    question: 'Питање',
    writeInNumbers: 'упиши бројевима',
    finish: 'Заврши',
    errorTranslatingTitle: 'Грешка у превођењу',
    errorTranslatingDescription:
      'Жао нам је! Нисмо могли превести ово питање. Уместо тога приказано је оригинално. Молимо контактирајте нашу подршку на: info@tellet.ai.',
  },
  sk: {
    next: 'Ďalej',
    question: 'Otázka',
    writeInNumbers: 'napíšte číslicami',
    finish: 'Dokončiť',
    errorTranslatingTitle: 'Chyba prekladu',
    errorTranslatingDescription:
      'Prepáčte! Tento dotaz sa nám nepodarilo preložiť. Namiesto toho sa zobrazuje originál. Kontaktujte prosím našu podporu na: info@tellet.ai.',
  },
  sl: {
    next: 'Naprej',
    question: 'Vprašanje',
    writeInNumbers: 'vpiši s številkami',
    finish: 'Dokončaj',
    errorTranslatingTitle: 'Napaka pri prevajanju',
    errorTranslatingDescription:
      'Oprostite! Teh vprašanj nismo mogli prevesti. Namesto tega je prikazan izvirnik. Prosimo, kontaktirajte našo podporo na: info@tellet.ai.',
  },
  es: {
    next: 'Siguiente',
    question: 'Pregunta',
    writeInNumbers: 'escribe en números',
    finish: 'Finalizar',
    errorTranslatingTitle: 'Error de traducción',
    errorTranslatingDescription:
      '¡Ups! No hemos podido traducir esta pregunta. Se muestra el original. Por favor, contacta con nuestro soporte en: info@tellet.ai.',
  },
  sv: {
    next: 'Nästa',
    question: 'Fråga',
    writeInNumbers: 'skriv med siffror',
    finish: 'Färdig',
    errorTranslatingTitle: 'Översättningsfel',
    errorTranslatingDescription:
      'Tyvärr! Vi kunde inte översätta denna fråga. Originalet visas istället. Kontakta vår support på: info@tellet.ai.',
  },
  sw: {
    next: 'Ifuatayo',
    question: 'Swali',
    writeInNumbers: 'andika kwa nambari',
    finish: 'Maliza',
    errorTranslatingTitle: 'Hitilafu ya Tafsiri',
    errorTranslatingDescription:
      'Pole! Hatukuweza kutafsiri swali hili. Badala yake, toleo la asili linaonyeshwa. Tafadhali wasiliana na msaada wetu kwa: info@tellet.ai.',
  },
  ta: {
    next: 'அடுத்தது',
    question: 'கேள்வி',
    writeInNumbers: 'எண்களில் எழுதவும்',
    finish: 'முடிக்கவும்',
    errorTranslatingTitle: 'மொழிபெயர்ப்பு பிழை',
    errorTranslatingDescription:
      'மன்னிக்கவும்! இந்த கேள்வியை மொழிபெயர்க்க முடியவில்லை. அதற்கு பதிலாக, அசல் பதிப்பு காட்டப்படுகிறது. உதவிக்கு எங்கள் ஆதரவுடன் தொடர்பு கொள்ளவும்: info@tellet.ai.',
  },
  th: {
    next: 'ถัดไป',
    question: 'คำถาม',
    writeInNumbers: 'เขียนเป็นตัวเลข',
    finish: 'เสร็จสิ้น',
    errorTranslatingTitle: 'ข้อผิดพลาดในการแปล',
    errorTranslatingDescription:
      'ขออภัย! เราไม่สามารถแปลคำถามนี้ได้ แสดงต้นฉบับแทน กรุณาติดต่อฝ่ายสนับสนุนของเราที่: info@tellet.ai.',
  },
  tr: {
    next: 'Sonraki',
    question: 'Soru',
    writeInNumbers: 'rakamlarla yazın',
    finish: 'Bitir',
    errorTranslatingTitle: 'Çeviri Hatası',
    errorTranslatingDescription:
      'Üzgünüz! Bu soruyu çeviremedik. Bunun yerine orijinal gösteriliyor. Yardım için lütfen destek ekibimizle iletişime geçin: info@tellet.ai.',
  },
  ur: {
    next: 'اگلا',
    question: 'سوال',
    writeInNumbers: 'اعداد میں لکھیں',
    finish: 'مکمل کریں',
    errorTranslatingTitle: 'ترجمے کی غلطی',
    errorTranslatingDescription:
      'معاف کیجیے! ہم اس سوال کا ترجمہ نہیں کر سکے۔ اصل ورژن دکھایا جا رہا ہے۔ براہ کرم ہماری مدد سے رابطہ کریں: info@tellet.ai.',
  },
  uz: {
    next: 'Keyingi',
    question: 'Savol',
    writeInNumbers: 'raqamlar bilan yozing',
    finish: 'Tugatish',
    errorTranslatingTitle: 'Tarjima xatosi',
    errorTranslatingDescription:
      "Kechirasiz! Biz bu savolni tarjima qila olmadik. Asl versiya ko'rsatilmoqda. Iltimos, qo'llab-quvvatlash xizmatimizga murojaat qiling: info@tellet.ai.",
  },
  uk: {
    next: 'Далі',
    question: 'Питання',
    writeInNumbers: 'напишіть цифрами',
    finish: 'Завершити',
    errorTranslatingTitle: 'Помилка перекладу',
    errorTranslatingDescription:
      "Вибачте! Ми не змогли перекласти це питання. Показується оригінал. Будь ласка, зв'яжіться з нашою підтримкою на: info@tellet.ai.",
  },
  vi: {
    next: 'Tiếp theo',
    question: 'Câu hỏi',
    writeInNumbers: 'viết bằng số',
    finish: 'Hoàn tất',
    errorTranslatingTitle: 'Lỗi dịch thuật',
    errorTranslatingDescription:
      'Xin lỗi! Chúng tôi không thể dịch câu hỏi này. Hiển thị bản gốc thay thế. Vui lòng liên hệ với bộ phận hỗ trợ của chúng tôi tại: info@tellet.ai.',
  },
  cy: {
    next: 'Nesaf',
    question: 'Cwestiwn',
    writeInNumbers: 'ysgrifennu mewn rhifau',
    finish: 'Gorffen',
    errorTranslatingTitle: 'Gwall Cyfieithu',
    errorTranslatingDescription:
      "Mae'n ddrwg gennym! Ni allwn gyfieithu'r cwestiwn hwn. Yn hytrach, mae'r fersiwn wreiddiol yn cael ei ddangos. Cysylltwch â'n cymorth ar: info@tellet.ai.",
  },
  id: {
    next: 'Selanjutnya',
    question: 'Pertanyaan',
    writeInNumbers: 'tulis dengan angka',
    finish: 'Selesai',
    errorTranslatingTitle: 'Kesalahan Terjemahan',
    errorTranslatingDescription:
      'Maaf! Kami tidak dapat menerjemahkan pertanyaan ini. Versi aslinya ditampilkan sebagai gantinya. Silakan hubungi dukungan kami di: info@tellet.ai.',
  },
};
